(function(angular){
	'use strict';

	angular
		.module('homePriceChartModule')
		.directive('laHomePriceChart', [
			'HIGHCHARTS_OPTIONS', 
			laHomePriceChartFunction
		]);

	function laHomePriceChartFunction(HIGHCHARTS_OPTIONS) {
		return {
			replace: true,
			restrict: 'E',
			scope: {},
			template: '<div id="la-price-chart"></div>',
			link: function() {

				Highcharts.setOptions(HIGHCHARTS_OPTIONS());
				
				var chart = new Highcharts.Chart({
					chart: {
						renderTo: 'la-price-chart',
						type: 'area'
					},
					series: [{
						color: {
							linearGradient: { x1: 0, y1: 1, x2: 1, y2: 0 },
							stops: [
								[0, '#F6A01A'],
								[1, '#F47735']
							]
						},
						data: [{
							x: 2012,
							y: 168.85
						},{
							x: 2013,
							y: 201.20
						},{
							x: 2014,
							y: 221.93
						},{
							x: 2015,
							y: 235.14
						},{
							x: 2016,
							y: 248.77
						}],
						fillColor: {
							linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
							stops: [
								[0, Highcharts.Color('#FF6A19').setOpacity(0.5).get('rgba')],
								[1, Highcharts.Color('#F6A01A').setOpacity(0).get('rgba')]
							]
						}
					}],
					xAxis: {
						title: {
							text: 'years'
						}
					},
					yAxis: {
						title: {
							text: 'LA Home Price'
						},
						min: 160,
						endOnTick: false
					}
				});
			}
		};
	}
})(window.angular);